import { Button, styled } from '@mui/material';

import type { Theme } from '@mui/material';

export const StyledButtonLink = styled(Button)(({ theme }: { theme: Theme }) => ({
	overflowWrap: 'break-word',
	margin: 0,
	color: theme.palette.tsGoColor.blue,
	backgroundColor: 'transparent',
	border: 'none',
	cursor: 'pointer',
	userSelect: 'none',
	maxWidth: '100%',
	textAlign: 'center',
	position: 'relative',
	display: 'inline-block',
	transitionProperty: 'color, background-color, border-color',
	transitionDuration: '0.1s',
	transitionTimingFunction: 'ease',
	borderRadius: theme.tsGoUnit.tsUnitHalf,
	padding: 0,
	fontSize: theme.typography.tsFontSize.small,
	boxSizing: 'border-box',
	fontWeight: theme.typography.tsFontWeight.semiBold,
	...(globalThis.cardProvider.IS_HSBC_PROVIDER_SETUP
		? {
				fontWeight: theme.typography.tsFontWeight.default,
				fontSize: theme.typography.pxToRem(theme.typography.tsFontSize.mini),
				textTransform: 'none',
				borderRadius: 0,
			}
		: {}),
}));
